import { render, staticRenderFns } from "./fileDropmenu.vue?vue&type=template&id=76595bf2&scoped=true"
import script from "./fileDropmenu.vue?vue&type=script&lang=js"
export * from "./fileDropmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76595bf2",
  null
  
)

export default component.exports